export default {
  pt: {
    pageTitle: "Pagamento",
    creditCardPageTitle: "Pagamento com cartão",
    creditCardMainTitle: "Dados do cartão",
    entryLabel: "Entrada",
    planDetailsTitle: "Detalhes dos Planos",
    planDetailsSubtitle: "Sobre os planos",
    understoodButton: "Entendi!",
    bikeHeroText: "BikeHero, seu herói pra todo pedal.",
    reminderTitle: "Lembrete",
    reminderIntro: "Estou ciente de que a cobrança do seguro ocorrerá em duas etapas:",
    reminderItem1Title: "Entrada",
    reminderItem1Body: "no ato da contratação, com a ativação da cobertura provisória imediata.",
    reminderItem2Title: "Parcelas",
    reminderItem2Body:
      "Será enviado um link da HDI Seguros por SMS junto com a emissão da apólice.",
    successTitle: "Pagamento confirmado!",
    successDescription: "Recebemos o pagamento do seu cartão.",
  },

  en: {
    pageTitle: "Payment",
    creditCardPageTitle: "Card payment",
    creditCardMainTitle: "Card details",
    entryLabel: "Down payment",
    planDetailsTitle: "Plan Details",
    planDetailsSubtitle: "About the plans",
    understoodButton: "I understand!",
    bikeHeroText: "BikeHero, your hero for every ride.",
    reminderTitle: "Reminder",
    reminderIntro: "I'm aware that insurance billing occurs in two stages:",
    reminderItem1Title: "Down payment",
    reminderItem1Body:
      "at the moment of contracting, with immediate provisional coverage activation.",
    reminderItem2Title: "Installments",
    reminderItem2Body: "An HDI Seguros link will be sent by SMS along with the policy issuance.",
    successTitle: "Payment confirmed!",
    successDescription: "We've received your card payment.",
  },
};
